import React from 'react';
import { CovalentBalanceItem } from '@shared/types/frontend';
import CloudWalletBalance from '@/components/shared/ConnectedWalletBalance';
import { useSession } from '@/contexts/LitSessionProvider';
import classNames from '@/lib/misc/classNames';
import MobileMenu from '../shared/MobileMenu';
export type AssetType = {
  name: string;
  symbol: string;
  value: number;
  change: number;
  logo: string;
  amount?: string;
};
interface PortfolioAssetSelectProps {
  fromAssets: CovalentBalanceItem[];
  setFromAssets: (_: CovalentBalanceItem[]) => void;
  handleConfirm?: () => void;
  confirmBtnClass?: string;
  confirmBtnParentDivClass?: string;
  singleSelect?: boolean;
  mobile?: boolean;
  showSolana?: boolean;
  selectOne?: boolean;
}
export default function PortfolioAssetSelect({
  fromAssets,
  setFromAssets,
  confirmBtnParentDivClass,
  singleSelect = false,
  showSolana = true,
  selectOne,
  handleConfirm
}: PortfolioAssetSelectProps) {
  const {
    PKP,
    connectedWalletAddress
  } = useSession();
  return <div className='bg-genius-indigo relative w-full' data-sentry-component="PortfolioAssetSelect" data-sentry-source-file="PortfolioAssetSelect.tsx">
      <div>
        <div className='w-full mt-2'>
          <div className={`w-full overflow-auto no-scrollbar  `}>
            <CloudWalletBalance wallet={PKP?.additionalEthAddress || connectedWalletAddress} solanaAddress={showSolana ? PKP?.solanaAddress : null} selectedInputAssets={fromAssets} setSelectedInputAssets={setFromAssets} showHeader={false} confirm={handleConfirm} singleSelect={singleSelect} selectOne={selectOne} data-sentry-element="CloudWalletBalance" data-sentry-source-file="PortfolioAssetSelect.tsx" />
          </div>
          {!singleSelect && <MobileMenu />}
        </div>
      </div>

      {fromAssets.length >= 1 && <div className={classNames('fixed bottom-6 flex w-[85%] justify-center items-center p-4', confirmBtnParentDivClass)}></div>}
    </div>;
}